window.SLIDECART_UPDATED = function (cart) {
    const checkoutForm = document.getElementById("slidecart-checkout-form");
    let slideCartAffirmDiv = document.getElementById("slide-cart-affirm");
  
    const existingAffirmElements =
      document.querySelectorAll(".slide-cart-affirm");
  
    for (const element of existingAffirmElements) {
      element.parentNode.removeChild(element);
    }
  
    slideCartAffirmDiv = document.createElement("div");
    slideCartAffirmDiv.classList.add("slide-cart-affirm");
    slideCartAffirmDiv.style.textAlign = "center";
    if (checkoutForm) {
      const parentElement = checkoutForm.parentNode;
      parentElement.insertBefore(slideCartAffirmDiv, checkoutForm);
    }
  
    if (cart.total_price >= 79900) {
      slideCartAffirm = Math.ceil(cart.total_price / 2400.0);
    } else if (cart.total_price < 15000) {
      slideCartAffirm = Math.ceil(cart.total_price / 1200.0);
    } else {
      slideCartAffirm = Math.ceil(cart.total_price / 1800.0);
    }
  
    if (slideCartAffirmDiv) {
      slideCartAffirmDiv.innerHTML =
        '0% APR financing as low as&nbsp; <div onclick="setAffirmTrigger(this)" class="affirm-trigger inline-block hover:cursor-pointer">$' +
        slideCartAffirm.toString() +
        '/mo</div>&nbsp;with <svg id="Affirm_2_Color_-_HEX" data-name="Affirm 2 Color - HEX" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 428.55 171"><defs><style>.cls-1,.cls-2{fill:#101820;}.cls-1,.cls-3{fill-rule:evenodd;}.cls-3{fill:#4a4af4;}</style></defs><path class="cls-1" d="M116.62,449.32c-5.3,0-8-2.61-8-6.9,0-8,8.92-10.69,25.19-12.42,0,10.66-7.21,19.32-17.24,19.32Zm7-59.95c-11.63,0-25,5.47-32.26,11.26l6.63,14c5.82-5.33,15.23-9.89,23.72-9.89,8.07,0,12.53,2.7,12.53,8.14,0,3.65-2.95,5.5-8.53,6.23-20.86,2.7-37.21,8.46-37.21,24.53,0,12.74,9.07,20.45,23.24,20.45,10.12,0,19.12-5.62,23.4-13v11H154V416c0-19-13.19-26.67-30.37-26.67Z" transform="translate(-88.52 -293.05)"></path><path class="cls-1" d="M312.91,391.44V462h20.18V428c0-16.15,9.78-20.9,16.59-20.9a15.47,15.47,0,0,1,8.63,2.55L362,391a22.84,22.84,0,0,0-9-1.63c-10.37,0-16.89,4.59-21.19,13.93V391.44H312.91" transform="translate(-88.52 -293.05)"></path><path class="cls-1" d="M455.52,389.37c-10.67,0-18.65,6.3-22.8,12.38-3.85-7.85-12-12.38-21.8-12.38-10.66,0-18.05,5.92-21.46,12.74V391.44H370V462H390.2V425.67c0-13,6.83-19.29,13.2-19.29,5.77,0,11.07,3.73,11.07,13.36V462h20.16V425.67c0-13.19,6.66-19.29,13.33-19.29,5.34,0,11,3.88,11,13.22V462h20.16V413.22c0-15.85-10.67-23.85-23.56-23.85" transform="translate(-88.52 -293.05)"></path><path class="cls-1" d="M263.8,391.44H245.52v-7.17c0-9.34,5.33-12,9.92-12a20.18,20.18,0,0,1,9,2.25l6.22-14.23s-6.31-4.12-17.78-4.12c-12.89,0-27.56,7.27-27.56,30.08v5.19H194.77v-7.17c0-9.34,5.32-12,9.92-12a19.12,19.12,0,0,1,9,2.25l6.22-14.23c-3.71-2.17-9.68-4.12-17.77-4.12-12.89,0-27.56,7.27-27.56,30.08v5.19H162.9V407h11.71v55h20.16V407h30.59v55h20.16V407H263.8V391.44" transform="translate(-88.52 -293.05)"></path><rect class="cls-2" x="187.32" y="98.39" width="20.14" height="70.53"></rect><path class="cls-3" d="M276.58,379.45h19.73c11.51-36.19,50.56-68,97-68,56.48,0,105.29,43,105.29,109.94A137.58,137.58,0,0,1,493,462h19.15l.19-.66a162.2,162.2,0,0,0,4.74-39.89c0-74.65-54.4-128.38-123.73-128.38-54.46,0-103,37.8-116.76,86.4Z" transform="translate(-88.52 -293.05)"></path></svg>';
    }
  };
  
  window.SLIDECART_LOADED = function (cart) {
    // Fires once the cart has loaded
  
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          __slidecart: localStorage.getItem("__slidecart"),
        },
      }),
    })
      .then((res) => {
        console.log("Request complete! response:", res);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  
  window.SLIDECART_ADD_TO_CART = function ({ id, quantity }) {
    // Fires whenever an item has been added to cart
    if (!window.dataLayer) window.dataLayer = [];
  
    const blockedIds = [
      44472075813170,
      44472075878706,
      44472075944242,
      44472075977010,
      44472076009778,
      44472076042546,
      44472076665138,
      44472076697906,
      44472076566834,
      44472076632370,
      44472076599602,
      44472076534066,
      44472072601906,
      44472072634674,
      44472072667442,
      44472072700210,
      44472072732978,
      44472072765746
    ];
    
    if (!blockedIds.includes(id) && !document.querySelector('#slidecarthq').classList.contains('prevent-open')) {
      window.SLIDECART_OPEN();
    }
  
    dataLayer.push({
      event: "custom_event",
      eventName: "product_added_to_cart",
      product_id: id,
      quantity: quantity,
    });
  };
  
  window.SLIDECART_OPENED = function () {
    // Fires whenever Slide Cart has been opened
    if (!window.dataLayer) window.dataLayer = [];
  
    dataLayer.push({
      event: "custom_event",
      eventName: "cart_viewed",
    });
  };
  